import React from 'react';
import * as R from 'ramda';
import { AddCreditCardForm } from '../modal/addCreditCardForm';
import creditCards from '../../../assets/images/svg/053-credit-cards.svg';


export const CreditCardTile = ({ paymentMethod, user }) => {
    return (
        <div className="card shadow-xs mb-2">
            <div className="card-header flex-row justify-content-around">
                <img className="img-fluid w-4 my-auto mr-2 h-5" src={creditCards} alt="creditCards" />
                <h2 className="h5 text-uppercase font-weight-bolder my-auto mr-auto">Carte de crédit</h2>
            </div>
            <div className="card-body py-0">
                <AddCreditCardForm paymentMethod={paymentMethod} user={user} />
                {
                    !R.isNil(paymentMethod) ? <button type="button" className="btn btn-block btn-alert-info px-3 mb-xs" data-toggle="modal" data-target="#payment">Modifier la méthode de paiement</button> : ''
                }
            </div>
        </div>
    );
};